import {
    CATEGORY_SUMMARY_QUESTIONS_REQUESTED,
    CATEGORY_SUMMARY_QUESTIONS_SUCCESS,
    CATEGORY_SUMMARY_QUESTIONS_FAILURE,
} from './types';

export const requestCategorySummaryQuestions = () => {
    return { type: CATEGORY_SUMMARY_QUESTIONS_REQUESTED };
};

export const categorySummaryQuestionsSucceded = () => {
    return { type: CATEGORY_SUMMARY_QUESTIONS_SUCCESS };
};

export const categorySummaryQuestionsFailed = () => {
    return { type: CATEGORY_SUMMARY_QUESTIONS_FAILURE };
};



// WEBPACK FOOTER //
// ./src/redux/ui/actions.js